import nav from './nav';
import basket from './basket';
import subscriber from './subscribe';
import search_field from './search_field';
import library_filters from './library_filters';
import cookies from './cookies';
import urgent_msg from './urgent_msg';
import { publish } from '../util/pubsub';

const initial_width = window.innerWidth;

const DESKTOP = 0;
const MEDIUM = 1;
const MOBILE = 2;

const get_width_bracket = width => {
    if (width > (1280 * 0.9)) {
        return DESKTOP;
    } else if (width > 640) {
        return MEDIUM;
    }
    return MOBILE;
}

let current_width_bracket = get_width_bracket(initial_width);
window.addEventListener('resize', () => {
    const width_bracket = get_width_bracket(window.innerWidth);
    if (width_bracket !== current_width_bracket) {
        publish('WIDTH_BRACKET_CHANGED');
    }
    current_width_bracket = width_bracket;
});

(() => {
    var f = document.getElementById('desktop-filters');
    if (!f) return;
    var l = Array.from(f.querySelectorAll('.filter'));
    l.forEach(function(li) {
        var link = li.querySelector('a');
        if (!link) return;
        if (window.location.href.includes(link.getAttribute('href'))) {
            li.classList.add('active');
            link.setAttribute('href', link.getAttribute('href').replace(/\?.+$/, ''));
        }
    });
})();

(() => {
    var f = document.getElementById('filters-mobile');
    if (!f) return;
    var l = Array.from(f.querySelectorAll('.filter'));
    l.forEach(function(li) {
        var link = li.querySelector('a');
        if (!link) return;
        if (window.location.href.includes(link.getAttribute('href'))) {
            li.classList.add('active');
            link.setAttribute('href', link.getAttribute('href').replace(/\?.+$/, ''));
        }
    });
})();
